import ArticleInfo from './ArticleInfo';

export default ArticleInfo;
